import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const SmartMapPage = lazy(() => import('@repo/ui/features/smart-map').then((mod) => ({ default: mod.SmartMapPage })));

export default function SmartMapRoute() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement de la carte intelligente..." />}>
      <SmartMapPage />
    </Suspense>
  );
}
